/*
 * © 2026 Ecsper Ltd. All rights reserved.
 * SPDX-License-Identifier: LicenseRef-Ecsper-Proprietary
 * Unauthorised use, copying, or distribution is strictly prohibited.
 */

import type { EcsperClient } from '@ecsper/api-client';
import type { AnalysisResponse } from '@ecsper/api-client';

export async function fetchAnalysis(
  apiClient: EcsperClient,
  reportId: string,
  analysisType: 'compliance_check' | 'gap_analysis' | 'tone_check',
): Promise<AnalysisResponse> {
  return apiClient.analyseReport(reportId, analysisType);
}
